import { __decorate, __metadata } from 'tslib';
import { NotEnumerable, Storable, nameOf } from '@tencent/workbench-core';

class ParamMetadata extends Storable {
    get service() {
        return this.rawService;
    }
    set service(value) {
        this.rawService = value;
        this.name = nameOf(value);
    }
    toJSON() {
        return {
            service: nameOf(this.rawService),
            name: this.name,
            use: this.typeName,
            expression: this.expression,
        };
    }
}
__decorate([
    NotEnumerable(),
    __metadata("design:type", Object)
], ParamMetadata.prototype, "rawService", void 0);

export { ParamMetadata };
//# sourceMappingURL=param-metadata.js.map
